import { FULFILMENTSTATUS_LIST } from '@/config'
import { shopTypeList } from '@/utils/dict'
export const tabMode = {
  toBeShipped: 'TO_BE_SHIPPED',
  shipped: 'SHIPPED',
  all: 'all',
  error: 'error'
}

export const queryType = [
  { label: window.$t('stores::order::order_number'), value: 'ORDER_NO', placeholder: window.$t('stores::order::input_order_number') },
  { label: window.$t('stores::order::email'), value: 'EMAIL', placeholder: window.$t('stores::order::rule_email') },
  { label: window.$t('stores::order::customer_name'), value: 'CUSTOMER_NAME', placeholder: window.$t('stores::order::input_customer_name') },
  { label: window.$t('stores::order::goods_name'), value: 'PRODUCT_NAME', placeholder: window.$t('stores::order::input_goods_name') },
  { label: 'SPU', value: 'SPU', placeholder: window.$t('stores::order::input_spu') },
  { label: 'SKU', value: 'SKU_CODE', placeholder: window.$t('stores::order::input_sku') },
  { label: window.$t('stores::order::domain'), value: 'DOMAIN', placeholder: window.$t('stores::order::input_domain') },
  // {label: '渠道来源', value: 'SOURCE', placeholder: '请输入渠道来源查找'},
  { label: window.$t('stores::order::fulfilment_number'), value: 'TRACK_NO', placeholder: window.$t('stores::order::input_fulfilment_number') },
  { label: window.$t('stores::order::promo_code'), value: 'DISCOUNT_CODE', placeholder: window.$t('stores::order::input_promo_code') },
  { label: window.$t('stores::order::pay_number'), value: 'PAYMENT_NO', placeholder: window.$t('stores::order::input_pay_number') }
]

export const queryTimeType = [
  { label: window.$t('stores::order::create_time'), value: 'createdTime' },
  { label: window.$t('stores::order::pay_time'), value: 'payTime' }
]

export const orderStatus = [
  { label: window.$t('stores::order::pay_fail'), value: 'PAYMENT_FAILED' },
  { label: window.$t('stores::order::wait_pay'), value: 'TO_BE_PAID' },
  { label: window.$t('stores::order::wait'), value: 'TO_BE_SHIPPED' },
  { label: window.$t('stores::order::shipping'), value: 'SHIPPED' },
  { label: window.$t('stores::order::cancel'), value: 'CANCELLED' }
]

export const orderRefundStatus = [
  { label: window.$t('stores::order::refund_all'), value: 2 },
  { label: window.$t('stores::order::refund_fail'), value: -1 },
  { label: window.$t('stores::order::refund_some'), value: 1 }
  // {label: '未退款', value: 0},
]

export const orderStatusByUnpaid = [
  { label: window.$t('stores::order::pay_fail'), value: 'PAYMENT_FAILED' },
  { label: window.$t('stores::order::wait_pay'), value: 'TO_BE_PAID' }
]

export const searchConfigs = [
  {
    key: ['filterObj', 'target'],
    searchType: 'selectInput',
    componentData: {
      options: [
        { label: window.$t('stores::order::platform_order'), value: 'order_no' },
        { label: window.$t('stores::order::store_order'), value: 'source_no' },
        { label: window.$t('stores::order::customer_name'), value: 'customer' },
        { label: window.$t('stores::order::customer_email'), value: 'email' },
      ],
    }
  },
  {
    key: 'mallType',
    label: window.$t('stores::order::belong_platform'),
    searchType: 'select',
    componentData: {
      filterable: true,
      placeholder: window.$t('system::common::select_placeholder'),
      clearable: true,
      options: shopTypeList
    }
  },
  {
    key: 'shopId',
    label: window.$t('stores::order::belong_store'),
    searchType: 'dict',
    componentData: {
      cache: false,
      dictKey: 'shop_id',
      placeholder: window.$t('stores::order::belong_store'),
      filterable: true,
      clearable: true
    }
  },
  // {
  //   key: 'salesStatus',
  //   label: window.$t('stores::order::sales_status'),
  //   searchType: 'select',
  //   componentData: {
  //     filterable: true,
  //     clearable: true,
  //     placeholder: window.$t('system::common::select_placeholder'),
  //     options: [
  //       { label: window.$t('stores::order::after_none'), value: '0' },
  //       { label: window.$t('stores::order::after_ongoing'), value: '1' },
  //       { label: window.$t('stores::order::after_complete'), value: '2' },
  //       { label: window.$t('stores::order::after_error'), value: '3' },
  //       { label: window.$t('stores::order::after_cancel'), value: '4' }
  //     ]
  //   }
  // },
  {
    key: 'fulfilmentStatus',
    label: window.$t('stores::order::fulfilment_status'),
    searchType: 'select',
    componentData: {
      filterable: true,
      clearable: true,
      placeholder: window.$t('system::common::select_placeholder'),
      options: FULFILMENTSTATUS_LIST
    }
  },
  {
    key: 'searchDate',
    label: window.$t('stores::order::pay_time'),
    searchType: 'selectDatepicker',
    componentData: {
      options: [{ label: window.$t('stores::order::pay_time'), value: 'payTime', keys: ['createTime', 'endTime'] }],
      dateComponentData: {
        startPlaceholder: window.$t('stores::order::start_date'),
        endPlaceholder: window.$t('stores::order::end_date')
      },
      clearable: true
    }
  },
  {
    key: ['minNumber', 'maxNumber'],
    label: window.$t('stores::order::order_fee'),
    searchType: 'numberRange',
    componentData: {
      startPlaceholder: window.$t('stores::order::min_price'),
      endPlaceholder: window.$t('stores::order::max_price')
    }
  },
  {
    key: 'createDate',
    label: window.$t('stores::order::create_time'),
    searchType: 'selectDatepicker',
    componentData: {
      options: [{ label: window.$t('stores::order::create_time'), value: 'createTime', keys: ['orderCreateTimeStart', 'orderCreateTimeEnd'] }],
      dateComponentData: {
        startPlaceholder: window.$t('stores::order::start_date'),
        endPlaceholder: window.$t('stores::order::end_date')
      },
      clearable: true
    }
  },
]

export const orderListColumns = [
  {
    prop: 'orderNo',
    label: window.$t('stores::order::platform_order'),
    minWidth: '250',
    fixed: 'left'
  },
  {
    prop: 'sourceNo',
    label: window.$t('stores::order::store_order'),
    width: '200'
  },
  {
    prop: 'consigneeName',
    label: window.$t('stores::order::customer'),
    minWidth: '160'
  },
  {
    prop: 'email',
    label: window.$t('stores::order::email'),
    minWidth: '200'
  },
  {
    prop: 'payTotalAmount',
    label: window.$t('stores::order::order_fee'),
    width: '130'
  },
  {
    prop: 'quantity',
    label: window.$t('stores::order::goods'),
    width: '100'
  },
  {
    prop: 'mallType',
    label: window.$t('stores::order::belong_platform'),
    width: '130'
  },
  {
    prop: 'shopName',
    label: window.$t('stores::order::store'),
    minWidth: '160'
  },
  {
    prop: 'payStatus',
    label: window.$t('stores::order::pay_status'),
    width: '120'
  },
  {
    prop: 'fulfillmentStatus',
    label: window.$t('stores::order::fulfilment_status'),
    width: '120'
  },
  // {
  //   prop: 'salesStatus',
  //   label: window.$t('stores::order::sales_status'),
  //   width: '120'
  // },
  {
    prop: 'payType',
    label: window.$t('stores::order::pay_type'),
    width: '120'
  },
  {
    prop: 'createTime',
    label: window.$t('stores::order::create_time'),
    minWidth: '200'
  },
  {
    prop: 'payTime',
    label: window.$t('stores::order::pay_time'),
    minWidth: '200'
  },
  {
    prop: 'operation',
    label: window.$t('stores::order::operate'),
    fixed: 'right',
    width: '120'
  }
]

export const orderDetailItems = [
  {
    prop: 'imageUrl',
    width: 90
  },
  {
    prop: 'title',
    width: 336
  },
  {
    prop: 'price'
  },
  {
    prop: 'saleAmount'
  }
]

export const shipmentDetailItems = [
  {
    prop: 'imageUrl',
    width: '90'
  },
  {
    prop: 'title',
    minWidth: '450'
  },
  {
    prop: 'quantity'
  }
]
